

    <!-- body section open -->
<img  *ngIf="routeData?.status == 'success'" src="https://infinity9.gotrackier.com/pixel?av=612df4c302535a0b13372bab" />

    <div class="UNFAPP-signlog-full-area">
        <div class="netjee-pymnt-stus-bx">
            <div class="netjee-pymnt-stushdr">
                <img src="images/NEET/green-big-tick.svg" alt="">
                <h3 class="netjee-pymnt-title" *ngIf="routeData?.status == 'success'">Thank you for enrolling</h3>
                <h3 class="netjee-pymnt-title" *ngIf="routeData?.status == 'fail'">Payment Fails</h3>
                <h4 class="netjee-pymnt-subtitle">Course details</h4>
            </div>
            <div class="netjee-pymnt-stus-przinforow">
                <div>Course start date</div>
                <div class="prce" > {{lastDate[routeData?.examName][routeData?.grade][routeData?.batchid]}}</div>
                
            </div>
            <div class="netjee-pymnt-stus-przinforow">
                <div>
                    Remaining payment<br>
                    <small>Pay Now to avail additional</small><br>
                    <span class="discount-tag">20% discount</span>

                </div>
                <div class="prce">Rs 38,999</div>
            </div>
            <div class="netjee-pymnt-actnarea">
                <button class="neetJeepage-frm-btn auto" *ngIf="routeData?.status == 'success'" (click)='downloadInvoice()'>Download Invoice</button>
                <button class="neetJeepage-frm-btn auto" *ngIf="routeData?.status == 'fail'" (click)='retry()'>Retry</button>
            </div>
        </div>
    </div>
    <!-- body section closed -->
